document.addEventListener("DOMContentLoaded", () => {
  const counterFields = document.querySelectorAll("[data-counter]");
  counterFields.forEach((field) => {
    const targetMaxLength = field.maxLength;
    if (!targetMaxLength) {
      return;
    }
    const helpText = field.insertAdjacentElement('afterend', document.createElement('p'));
    helpText.classList.add("help-block");
    helpText.textContent = targetMaxLength + window.gettext(" characters remaining");

    field.addEventListener("input", (event) => {
      const targetLength = event.target.value.length;
      const remainingChars = targetMaxLength - targetLength;
      helpText.textContent = remainingChars + window.gettext(" characters remaining");
      if (remainingChars <= 0) {
        helpText.classList.add("alert-warning");
      } else {
        helpText.classList.remove("alert-warning");
      }

    });
  });
});
